import React from 'react';
import { BrowserRouter, Routes, Route } from 'react-router-dom';
import Dashboard from './pages/Dashboard';
import Workspace from './pages/Workspace';
import AuditLog from './pages/AuditLog';
import SystemParams from './pages/SystemParams';
import MemoryBank from './pages/MemoryBank';

export default function App() {
  return (
    <BrowserRouter basename="/wudaidev">
      <Routes>
        <Route path="/" element={<Dashboard />} />
        <Route path="/project/:name" element={<Workspace />} />
        <Route path="/audit" element={<AuditLog />} />
        <Route path="/params" element={<SystemParams />} />
        <Route path="/memory" element={<MemoryBank />} />
      </Routes>
    </BrowserRouter>
  );
}
